import { Children, forwardRef } from 'react';
import styled from 'styled-components';

const List = styled.ul`
    margin: 0;
    list-style: none;
    padding: 0;
`;

const SemanticList = forwardRef(({ children, ...props }, ref) => (
    <List {...props} ref={ref}>
        {Children.map(children, (child) => (child ? <li>{child}</li> : null))}
    </List>
));

export default SemanticList;
